<div class="flex align-center full-width cart-total" >
    <div class="flex align-center justify-center total-icon">
        <div class="flex flex-column">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
                <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd"
                      id="top-cart"
                      d="M14.9931 4.41038L15.6063 1.78241C15.7309 1.24839 16.207 0.870605 16.7553 0.870605H18.8202C19.4718 0.870605 20.0001 1.39887 20.0001 2.05052C20.0001 2.70217 19.4718 3.23044 18.8202 3.23044H17.6916L16.1447 9.84387L15.4472 14.0286C15.3555 14.5791 14.831 14.9479 14.282 14.8481L2.91312 12.781C2.53851 12.7129 2.23508 12.438 2.13048 12.0719L0.305686 5.6851C0.123167 5.04628 0.602831 4.41038 1.26721 4.41038H14.9931Z"
                      fill="white"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="3" viewBox="0 0 12 3" fill="none"
                 id="bottom-cart">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5ZM12 1.5C12 2.32843 11.3284 3 10.5 3C9.67157 3 9 2.32843 9 1.5C9 0.671573 9.67157 0 10.5 0C11.3284 0 12 0.671573 12 1.5Z"
                      fill="white"/>
            </svg>
        </div>
        <div class="flex align-center justify-center amount"><p class="m-0">{{ quantity }}</p></div>
    </div>

    <div class="flex flex-column align-start justify-center flex-grow">
        <p class="caption bold m-0">Total Price</p>
        <div class="total flex align-center gap-1">
            <!-- Final total price -->
            <h3 class="m-0 text-success">{{ total | currency: 'USD' }}</h3>

            <!-- Show crossed-out original price only if discount exists -->
            <ng-container *ngIf="totalRaw">
                <h4
                    *ngIf="totalRaw > total"
                    class="m-0 text-muted"
                    style="text-decoration: line-through;"
                >
                    {{ totalRaw | currency: 'USD' }}
                </h4>
            </ng-container>

            <p *ngIf="freq" class="p3 lvl-1 m-0">{{ freq | paymentSuffix }}</p>
        </div>
    </div>
</div>
